import { usePermission } from "../../context/permission/PermissionContext";
import { RestrictedComponentProps } from "../../types/permission";

export const RestrictedComponent = ({
  permission,
  children,
}: RestrictedComponentProps) => {
  const { hasPermission } = usePermission();
  return hasPermission(permission) ? <>{children}</> : null;
};
